import React from 'react';
import PropTypes from 'prop-types';
import BackgroundVideo from 'epic-react-common/src/components/BackgroundVideo';
import VisibilitySensor from 'react-visibility-sensor';
import {Link} from 'react-router-dom';
import {generateRoutePath} from 'epic-ue-locale-mode';

export default class Header extends React.PureComponent {
    static propTypes = {
        background: PropTypes.object,
        headerData: PropTypes.object,
        tablet: PropTypes.bool,
        mobile: PropTypes.bool
    };

    state = {
        show: false,
        videoInView: false
    };

    onVideoChange = (isVisible) => {
        if (isVisible) {
            this.setState({
                videoInView: isVisible
            });
        } else if (!isVisible && this.state.videoInView) {
            this.setState({videoInView: isVisible});
        }
    };

    render() {
        const {background, tablet, mobile, headerData} = this.props;
        const {content, title, buttonHref, buttonLabel, secondaryButtonHref, secondaryButtonLabel} =
            headerData;

        return (
            <section
                className={`careers-header ${this.state.videoInView ? 'runAnimation' : ''} ${
                    mobile ? 'mobile' : ''
                } ${tablet ? 'tablet' : ''}`}>
                <div className={`background-type ${background.type}`}>
                    <div className="background-wrapper">
                        <VisibilitySensor
                            onChange={this.onVideoChange}
                            partialVisibility
                            scrollCheck={true}
                            scrollDelay={100}>
                            <BackgroundVideo
                                background={background}
                                enableRatioHelper={true}
                                play={this.state.videoInView && !this.state.show}
                                mute={true}
                                mobile={mobile}
                                tablet={tablet}
                                playsInline
                            />
                        </VisibilitySensor>
                    </div>

                    <div className="container-fluid content-wrapper">
                        <div className="intro-desc-section">
                            <div className="intro-desc-wrapper">
                                <div className="intro-desc-content">
                                    <h1 className="title uppercase">{title}</h1>
                                    <p> {content} </p>
                                </div>
                            </div>
                            <div className="intro-links-wrapper">
                                {buttonHref && buttonLabel && (
                                    <Link
                                        className="ue-cta-button button-lg button-hover"
                                        to={generateRoutePath(buttonHref)}>
                                        {buttonLabel}
                                    </Link>
                                )}
                                {secondaryButtonHref && secondaryButtonLabel && (
                                    <Link
                                        className="ue-cta-button ue-cta-button-inverted button-lg button-hover"
                                        to={generateRoutePath(secondaryButtonHref)}>
                                        {secondaryButtonLabel}
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
